export default __webpack_public_path__ + "static/media/spa-image-01.cb283d0c.png";